/* Published source tracker configuration; apex only and consent-aware. */
(() => {
	const config = document.querySelector('[data-yp-tracker-config]');
	const params = new URLSearchParams(location.search);
	const allowed = ['getyangoplay.com', 'www.getyangoplay.com'].includes(location.hostname)
		&& config?.dataset.ypLive === 'true' && config.dataset.ypPage !== 'welcome'
		&& !params.has('preview_theme_id') && !params.has('code');
	window.IS_PROD = allowed;
	window.SENTRY_ENV = allowed ? 'production' : 'development';
	if (!allowed || window.YPTrackersBootstrap) return;
	window.YPTrackersBootstrap = true;

	const append = (src, crossOrigin = false) => {
		const script = document.createElement('script');
		script.async = true;
		if (crossOrigin) script.crossOrigin = 'anonymous';
		script.src = src;
		document.head.appendChild(script);
	};
	const loadSentry = () => {
		if (window.YPSentryLoaded) return;
		window.YPSentryLoaded = true;
		window.sentryOnLoad = () => Sentry.init({
			environment: window.SENTRY_ENV,
			tracesSampleRate: 0,
			beforeSend(event) {
				const ua = navigator.userAgent || '';
				if (/FBAN|FBAV|Instagram|TikTok|Twitter|Threads/i.test(ua)) {
					const frames = event.exception?.values?.[0]?.stacktrace?.frames;
					if (!frames?.some(frame => frame.filename?.includes('getyangoplay'))) return null;
				}
		return event;
			},
		});
		append('https://js.sentry-cdn.com/23f51c01434f1687fe88e9b98c76f7c2.min.js', true);
	};
	let clarityPending = false;
	let claritySettled = false;
	const loadClarity = () => {
		if (clarityPending || claritySettled) return;
		clarityPending = true;
		window.clarity = window.clarity || function () {
			(window.clarity.q = window.clarity.q || []).push(arguments);
		};
		const script = document.createElement('script');
		script.async = true;
		script.src = 'https://www.clarity.ms/tag/wemgzlqlxj';
		script.onload = script.onerror = () => {
			clarityPending = false;
			claritySettled = true;
			applyConsent();
		};
		document.head.appendChild(script);
	};
	const loadGtm = () => {
		if (window.YPGtmLoaded) return;
		window.YPGtmLoaded = true;
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({'gtm.start': Date.now(), event: 'gtm.js'});
		['GTM-WBS2F4TK', 'GTM-MPKFHHTM'].forEach(id => append(`https://www.googletagmanager.com/gtm.js?id=${id}`));
	};
	const updateProviderConsent = (analytics, marketing) => {
		window.dataLayer = window.dataLayer || [];
		window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
		window.gtag('consent', 'update', {
			analytics_storage: analytics ? 'granted' : 'denied',
			ad_storage: marketing ? 'granted' : 'denied',
			ad_user_data: marketing ? 'granted' : 'denied',
			ad_personalization: marketing ? 'granted' : 'denied',
		});
		window.clarity?.('consentv2', {
			ad_Storage: marketing ? 'granted' : 'denied',
			analytics_Storage: analytics ? 'granted' : 'denied',
		});
		if (!analytics) window.Sentry?.close?.(0);
	};
	let previousConsent = null;
	const applyConsent = () => {
		const privacy = window.Shopify?.customerPrivacy;
		if (!privacy) return;
		let analytics = false;
		let marketing = false;
		try {
			analytics = privacy.analyticsProcessingAllowed();
			marketing = privacy.marketingAllowed();
		} catch {
			return;
		}
		updateProviderConsent(analytics, marketing);
		const revoked = (previousConsent?.analytics && !analytics)
			|| (previousConsent?.marketing && !marketing);
		if (revoked) {
			// The published GTM containers include custom tags that cannot be
			// reliably revoked in-place. A single reload removes their runtime;
			// the denied state then prevents them from loading again.
			window.location.reload();
			return;
		}
		if (analytics) {
			loadSentry();
			loadClarity();
			updateProviderConsent(analytics, marketing);
		}
		// Both GTM containers currently mix analytics and marketing vendors.
		// Requiring both permissions prevents custom marketing tags from firing
		// for an analytics-only visitor until the containers are separated.
		// Initialize our verified Clarity project before UET can initialize its
		// linked project. Microsoft's tag respects an existing Clarity runtime.
		if (analytics && marketing && claritySettled) loadGtm();
		previousConsent = {analytics, marketing};
	};
	let privacyFeatureRequested = false;
	const initializePrivacy = () => {
		if (privacyFeatureRequested) return;
		const loadFeatures = window.Shopify?.loadFeatures;
		if (typeof loadFeatures !== 'function') return;
		privacyFeatureRequested = true;
		try {
			loadFeatures.call(window.Shopify, [
				{name: 'consent-tracking-api', version: '0.1'},
			], error => {
				if (!error) applyConsent();
			});
		} catch {
			// Fail closed when Shopify cannot initialize the consent API.
		}
	};
	const handleConsent = () => {
		initializePrivacy();
		applyConsent();
	};
	document.addEventListener('visitorConsentCollected', handleConsent);
	document.addEventListener('DOMContentLoaded', initializePrivacy, {once: true});
	window.addEventListener('load', initializePrivacy, {once: true});
	initializePrivacy();
})();
